import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    template: null,
    result: null,
    signatures: null,
    test: null,
	duplicate: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.EMAIL_TEMPLATE_CREATE:
            return {
                ...state,
                isLoading: true
            }

        case types.EMAIL_TEMPLATE_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_CREATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.EMAIL_TEMPLATE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_UPDATE:
            return {
                ...state,
                isLoading: true
            }

        case types.EMAIL_TEMPLATE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_UPDATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_SEND:
            return {
                ...state,
                isLoading: true
            }

        case types.EMAIL_TEMPLATE_SEND_SUCCESS:
            return {
                ...state,
                result: action.result,
                isLoading: false,
                test: action.test
            }

        case types.EMAIL_TEMPLATE_SEND_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_RESET:
            return {
                ...state,
                template: null,
                result: null,
                test: null,
				duplicate: null
            }

        case types.EMAIL_TEMPLATE_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.EMAIL_TEMPLATE_FETCH_SUCCESS:
            return {
                ...state,
                template: action.template,
                isLoading: false
            }

        case types.EMAIL_TEMPLATE_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SIGNATURES_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.SIGNATURES_FETCH_SUCCESS:
            return {
                ...state,
                isLoading: false,
                signatures: {
                    ...state.signatures,
                    [action.application]: action.signatures
                }
            }

        case types.SIGNATURES_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SIGNATURE_UPDATE:
            return {
                ...state,
                isLoading: true
            }

        case types.SIGNATURE_UPDATE_SUCCESS: {
            const data = [...state.signatures[action.application]]
            const index = data.findIndex(item => item.id === action.signature.id)
            data.splice(index, 1, {...action.signature})

            return {
                ...state,
                isLoading: false,
                signatures: {
                    ...state.signatures,
                    [action.application]: data
                }
            }
        }

        case types.SIGNATURE_UPDATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SIGNATURE_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.SIGNATURE_DELETE_SUCCESS: {
            const data = [...state.signatures[action.application]]
            const index = data.findIndex(item => item.id === action.signature)
            data.splice(index, 1)

            return {
                ...state,
                isLoading: false,
                signatures: {
                    ...state.signatures,
                    [action.application]: data
                }
            }
        }

        case types.SIGNATURE_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SIGNATURE_CREATE:
            return {
                ...state,
                isLoading: true
            }

        case types.SIGNATURE_CREATE_SUCCESS: {
            const data = [...state.signatures[action.application]]

            return {
                ...state,
                isLoading: false,
                signatures: {
                    ...state.signatures,
                    [action.application]: [
                        ...data,
                        action.signature
                    ]
                }
            }
        }

        case types.SIGNATURE_CREATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

		case types.EMAIL_TEMPLATE_CLONE:
			return {
				...state,
				isLoading: true
			}

		case types.EMAIL_TEMPLATE_CLONE_SUCCESS:
			return {
				...state,
				duplicate: action.duplicate,
				isLoading: false
			}

		case types.EMAIL_TEMPLATE_CLONE_FAILED:
			return {
				...state,
				isLoading: false
			}

        default:
            return state
    }
}
